import React from 'react';
import UserOnboarding from '../components/UserOnboarding';
import { useMfeOptions } from 'src/contexts/MfeOptionsContext';
import { LoadingScreen } from 'src/components/LoadingScreen';
import { SIMPLEUI_EVENT_MAP } from 'src/constants/SimpleUIEvents';
import { Logger } from 'src/utils/Logger';

const App = (): JSX.Element => {
  const {
    isLoading,
    options: { isDemo }
  } = useMfeOptions();

  if (isLoading)
    return <LoadingScreen flow={SIMPLEUI_EVENT_MAP.LOADING_SPINNER.MFE_INIT} />;

  if (isDemo) {
    Logger.warn(
      'The demo mode of this MFE is deprecated and it is no longer supported. The property will be ignored.'
    );
  }

  return <UserOnboarding />;
};

export default App;
